import type { SelectorObj } from '../../shared.types'
import { getVariantSelectors, variantsComparator } from '../../utils/variantsUtils'
import type { DomApplier } from '../cssFeatures.types'

export const cursorDomApplier: DomApplier<'cursor'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ cursor, cursorVariants },
	accumulatedData
) => {
	if (!cursor) {
		return null
	}

	const cssInBreakpoint = cursor?.[breakpointId]
	if (!cssInBreakpoint) {
		return null
	}

	return Object.entries(cssInBreakpoint)
		.sort(variantsComparator(cursorVariants!))
		.reduce<SelectorObj>((acc, [variantKey, cssObj]) => {
			if (!cssObj) {
				return acc
			}

			const domSelector = getVariantSelectors(variantKey, cursorVariants, compId, accumulatedData).join(',')
			acc[domSelector] = cssObj

			return acc
		}, {})
}
